$(function() {
	// @codekit-prepend 'js/functions.js'
    // @codekit-prepend 'js/dropdown.js'
    
	// @codekit-prepend 'js/account.js'
	// @codekit-prepend 'js/application.js'
});